import { UploadOutlined } from "@ant-design/icons";
import { ProgressIndicator } from "@fluentui/react";
import { Button, Layout, notification } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext, useEffect } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { QuaiboDailyproductionDetails } from "../approvals/quaibo/QuaiboDailyproductionDetails";
import { RequestDialog } from "../approvals/RequestDialog";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { QuaiboDailyProductionUpload } from "./QuaiboDailyProductionUpload";
import { QuaiboProductionGrid } from "./QuaiboProductionGrid";
import { QuaiboRemarkPane } from "./QuaiboRemarkPane";
import { QuaiboSQuery } from "./QuaiboSQuery";
import { QuaiboWellAllocationExport } from "./QuaiboWellAllocationExport";
import { RythmBaseView } from "./visualizations/oil-rythm-plots/RythmBaseView";

const quaiboDailyProductionStoreCtx = createContext(QuaiboDailyProductionStore);

const { Content } = Layout;
export const QuaiboBaseView = observer(({ permission }) => {
  const quaiboDailyProductionStore = useContext(quaiboDailyProductionStoreCtx);

  useEffect(() => {
    async function loadInitailWellParameters() {
      try {
        if (!quaiboDailyProductionStore.wellParametersLoaded) {
          await quaiboDailyProductionStore.loadInitialWellParameters();
        }
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadInitailWellParameters();
  }, []);
  return (
    <Layout
      style={{
        background: "white",
        padding: "10px",
        borderTop: "2px solid #2FA8CC",
      }}
    >
      <Content>
        <div
          className="ms-Grid"
          dir="ltr"
          style={{
            background: "#fff",
            padding: "10px",
            borderTop: "2px solid red!important",
          }}
        >
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm6">
              <SubPageHeaderTitle
                title={`${quaiboDailyProductionStore.gridHeaderText}`}
              />
            </div>
            <div className="ms-Grid-col ms-sm2">
              {quaiboDailyProductionStore.isExporting && (
                <ProgressIndicator
                  description="exporting, please wait..."
                  styles={{ root: { textAlign: "center" } }}
                ></ProgressIndicator>
              )}
            </div>
            <div className="ms-Grid-col ms-sm4" style={{ textAlign: "right" }}>
              {quaiboDailyProductionStore.dailyProductions.size > 0 &&
                permission.canUpdate && (
                  <Button
                    type="primary"
                    icon={<UploadOutlined />}
                    onClick={async () => {
                      await quaiboDailyProductionStore.loadInitialWellParameters();
                      quaiboDailyProductionStore.clearFormValues();

                      quaiboDailyProductionStore.sheetName = "";
                      quaiboDailyProductionStore.showQuaiboDailyProductionDialog = true;
                    }}
                  >
                    Upload QUAIBO Field Daily Production & Evacuation
                  </Button>
                )}
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <QuaiboProductionGrid permission={permission} />

              <QuaiboDailyProductionUpload />
              <QuaiboRemarkPane />
              <QuaiboSQuery />
              <RequestDialog />
              <QuaiboDailyproductionDetails />
              <QuaiboWellAllocationExport />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {/* PLOT WRAPPERS */}
              <RythmBaseView />
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

